import React, { ReactNode } from "react"

import { ReactComponent as MoreIcon } from "assets/more.svg"

import IconButton, { IconButtonProps } from "@material-ui/core/IconButton"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"

type Option = {
  label: string
  icon?: ReactNode
  onClick: (e?: any) => void
  hidden?: boolean
  disabled?: boolean
  labelStyle?: string
}

type Props = {
  testId?: string
  options: Option[]
}
function MoreActions(props: Props & IconButtonProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault()
    evt.stopPropagation()
    setAnchorEl(evt.currentTarget)
  }

  const handleClosePopUp = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault()
    evt.stopPropagation()
    setAnchorEl(null)
  }
  const hideMoreIcons = props.options.every((opt) => opt.hidden === true)

  return hideMoreIcons ? (
    <></>
  ) : (
    <>
      <IconButton data-testid={props.testId} onClick={handleClick}>
        <MoreIcon />
      </IconButton>

      <Menu
        id="actions-list"
        anchorEl={anchorEl}
        /* TODO: investigate the code below as triggers a warning error and removing it doesn't seem to affect rendering
        // anchorOrigin={{
        //   vertical: "bottom",
        //   horizontal: "right",
        // }}
        */
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted={false}
        open={Boolean(anchorEl)}
        onClose={handleClosePopUp}
      >
        {props.options.map(
          (obj) =>
            !obj.hidden && (
              <MenuItem
                key={obj.label}
                data-testid={`more-actions-${obj.label
                  .toLowerCase()
                  .replaceAll(" ", "-")}`}
                onClick={(evt) => {
                  evt.stopPropagation()
                  evt.preventDefault()
                  obj.onClick()
                  setAnchorEl(null)
                }}
                disabled={obj?.disabled}
              >
                {!!obj.icon ? (
                  <ListItemIcon style={{ minWidth: "var(--spacing-xxl-2)" }}>
                    {obj.icon}
                  </ListItemIcon>
                ) : null}
                <ListItemText primary={obj.label} className={obj.labelStyle} />
              </MenuItem>
            ),
        )}
      </Menu>
    </>
  )
}

export default MoreActions
